import React, { useEffect, useState } from 'react';

const FloatingElements = () => {
  const [mousePos, setMousePos] = useState({ x: 50, y: 50 });
  const [stars, setStars] = useState([]);

  useEffect(() => {
    const newStars = Array.from({ length: 30 }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: Math.random() * 2 + 1,
      speed: Math.random() * 0.3 + 0.1,
      opacity: Math.random() * 0.2 + 0.05
    }));
    setStars(newStars);
  }, []);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePos({
        x: (e.clientX / window.innerWidth) * 100,
        y: (e.clientY / window.innerHeight) * 100
      });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-0">
      {stars.map((star) => {
        const offsetX = (mousePos.x - 50) * star.speed * 0.3;
        const offsetY = (mousePos.y - 50) * star.speed * 0.3;

        return (
          <div
            key={star.id}
            className="absolute rounded-full bg-white"
            style={{
              width: `${star.size}px`,
              height: `${star.size}px`,
              left: `${star.x}%`,
              top: `${star.y}%`,
              opacity: star.opacity,
              transform: `translate(${offsetX}px, ${offsetY}px)`,
              transition: 'transform 0.5s ease-out'
            }}
          />
        );
      })}
    </div>
  );
};

export default FloatingElements;
